import { gql } from '@apollo/client';

export default gql`
  mutation UpdateNotificationMutation($id: Int!, $patch: NotificationPatch!) {
    updateNotificationById(input: { notificationPatch: $patch, id: $id }) {
      notification {
        id
      }
    }
  }
`;
